import React from 'react';
import { Typography, useMediaQuery } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

// STYLES
import { SSubscriptionStepContainer } from './styles';

function SubscriptionStepTemplate({
  form,
  breadcrumbs,
  title,
  subtitle,
  description,
  error,
  alert,
}) {
  const matchesUpMd = useMediaQuery(theme => theme.breakpoints.up('md'));

  return (
    <SSubscriptionStepContainer fixed>
      {alert && <div className="alert-wrapper">{alert}</div>}
      {breadcrumbs}
      <Typography variant={matchesUpMd ? 'h2' : 'h4'} component="h1" className="step-title">
        {title}
        {subtitle && (
          <Typography variant="subtitle2" component="span">
            {subtitle}
          </Typography>
        )}
      </Typography>
      {!!description && (
        <div className="step-desc">
          <Trans
            components={{
              p: <Typography variant="body1" />,
              b: <Typography variant="h6" component="b" />,
            }}
          >
            {description}
          </Trans>
        </div>
      )}
      {error && <div className="error-wrapper">{error}</div>}
      <div className="form-wrapper">{form}</div>
    </SSubscriptionStepContainer>
  );
}

SubscriptionStepTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  subtitle: PropTypes.string,
  form: PropTypes.any,
  breadcrumbs: PropTypes.any,
  error: PropTypes.any,
  alert: PropTypes.any,
};

export default SubscriptionStepTemplate;
